import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, fileUrl } from "@/lib/api";
import { Megaphone, ChevronLeft, ChevronRight, ExternalLink } from "lucide-react";

const SLIDES = [
  "https://customer-assets-v7afamib.emergentagent.net/job_match-admin-portal-2/artifacts/xpbv9ocy_bts3.jpg",
  "https://customer-assets-gfyr7b9c.emergentagent.net/job_c1c09685-389b-4e72-b68b-c9e3acf4a320/artifacts/ar3s4wen_bts1.jpg",
  "https://customer-assets-gfyr7b9c.emergentagent.net/job_c1c09685-389b-4e72-b68b-c9e3acf4a320/artifacts/c813sldn_bts2.jpg",
];

function noticeHref(n) {
  if (n.link_type === "external" && n.external_link) return n.external_link;
  if (n.link_type === "file" && n.file_id) return fileUrl(n.file_id);
  return null;
}

function NoticeLink({ n, className }) {
  const href = noticeHref(n);
  if (href) {
    return (
      <a href={href} target="_blank" rel="noreferrer" className={className}>
        {n.title} {n.is_new && <span className="new-tag">New</span>}
      </a>
    );
  }
  return (
    <span className={className}>
      {n.title} {n.is_new && <span className="new-tag">New</span>}
    </span>
  );
}

export default function Home() {
  const [board, setBoard] = useState([]);
  const [whatsNew, setWhatsNew] = useState([]);
  const [slide, setSlide] = useState(0);

  useEffect(() => {
    api.get("/notices", { params: { category: "notice_board" } }).then((r) => setBoard(r.data));
    Promise.all([
      api.get("/notices", { params: { category: "whats_new" } }),
      api.get("/notices", { params: { category: "important_notices" } }),
    ]).then(([a, b]) => setWhatsNew([...a.data, ...b.data]));
  }, []);

  useEffect(() => {
    const t = setInterval(() => setSlide((s) => (s + 1) % SLIDES.length), 4000);
    return () => clearInterval(t);
  }, []);

  return (
    <div className="home" data-testid="home-page">
      {/* Notice board ticker */}
      <div className="notice-board" data-testid="notice-board">
        <div className="nb-head"><Megaphone size={18} /> Notice Board</div>
        <div className="nb-ticker">
          <div className="nb-track">
            {(board.length ? board : [{ id: "x", title: "Welcome to Bihar Technical Service Commission" }]).map((n) => (
              <NoticeLink key={n.id} n={n} className="nb-item" />
            ))}
          </div>
        </div>
        <Link to="/notice-board" className="nb-viewall" data-testid="notice-board-view-all">View All</Link>
      </div>

      {/* Slider + What's New */}
      <div className="home-grid">
        <div className="slider" data-testid="home-slider">
          {SLIDES.map((src, i) => (
            <div key={i} className={`slide ${i === slide ? "active" : ""}`}>
              <img src={src} alt="Bihar Technical Service Commission" />
              <div className="slide-caption">Bihar Technical Service Commission</div>
            </div>
          ))}
          <button className="slide-nav left" onClick={() => setSlide((s) => (s - 1 + SLIDES.length) % SLIDES.length)} data-testid="slide-prev"><ChevronLeft size={22} /></button>
          <button className="slide-nav right" onClick={() => setSlide((s) => (s + 1) % SLIDES.length)} data-testid="slide-next"><ChevronRight size={22} /></button>
          <div className="slide-dots">
            {SLIDES.map((_, i) => (
              <span key={i} className={i === slide ? "dot on" : "dot"} onClick={() => setSlide(i)} />
            ))}
          </div>
        </div>

        <div className="whats-new" data-testid="whats-new">
          <h2>What's New</h2>
          <ul>
            {whatsNew.length === 0 && <li className="empty">No updates yet.</li>}
            {whatsNew.map((n) => (
              <li key={n.id}>
                <span className="bullet">•</span>
                <NoticeLink n={n} className="wn-link" />
                {noticeHref(n) && <ExternalLink size={12} className="wn-ext" />}
              </li>
            ))}
          </ul>
          <div className="wn-actions">
            <Link to="/latest-update" className="btn-viewall" data-testid="whats-new-view-all">View All</Link>
            <button className="btn-archive">Archives</button>
          </div>
        </div>
      </div>
    </div>
  );
}
